<template>
  <div>

    <div class="content mt-20">
      <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
    </div>

    <div class="flex flex-right mt-20">
      <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
    </div>
  </div>
</template>
<script>
  import LoadButton from "../../components/LoadButton";
  import Pagination from "../../components/Pagination";
  import SmartTable from "../../components/SmartTable";
  import FormDialog from "../../components/FormDialog";
  import UploadImg from "../../components/UploadImg";
  export default{
    components: {
      UploadImg,
      FormDialog,
      SmartTable,
      Pagination,
      LoadButton
    },
    data(){
      return {
        searchParams: {
          page: 1
        },
        searchData: {},
        opt: [
        ],
        labels: [
          {prop: 'czdate', label: '时间'},
          {prop: 'opername', label: '操作人'},
          {prop: 'payamount', label: '金额'},
          {prop: 'paytype', label: '支付通道', map: this.globalData.pay},
        ],
        temp: {status:''}
      }
    },
    mounted(){
      this.getList()
    },
    methods: {
      search(stop){
        this.searchParams.page = 1
        this.getList(stop)
      },
      toPage(page){
        this.searchParams.page = page
        this.getList()
      },
      getList(callback){
        this.$http$({method: 'get', url: "/smartMeterServer/user/paymentlog/"+this.$store.state.LoginUser.userId,data:this.searchParams,  load: 1}, (data) => {
          callback ? callback() : ''
          this.searchData = data
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/user/ExchangeList.vue